import { useEffect, useState } from 'react';
import { fetchPodProduct, PodProductDetail } from '../../pod';

export function usePoDProduct(extProductId: string) {
  const [product, setProduct] = useState<PodProductDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Cancelled guard: the chevron popup's next/prev changes the id mid-flight.
    let cancelled = false;
    setLoading(true);
    setError(null);
    setProduct(null);

    fetchPodProduct(extProductId)
      .then((detail) => {
        if (cancelled) return;
        setProduct(detail);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [extProductId]);

  return { product, loading, error };
}
